import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

const featureIsEnabled = (name) => {
  return !![...window._features].find((feature) => {
    const [featureName, featureIsEnabled] = feature;
    return featureName === name && featureIsEnabled;
  });
}

export default createReactClass({
  propTypes: {
    name: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  },

  render() {
    const enabled = featureIsEnabled(this.props.name);
    const childrenCount = React.Children.count(this.props.children);

    let element = null;

    if (enabled && childrenCount === 1) {
      element = this.props.children;
    } else if (enabled && childrenCount > 1) {
      element = (
        <div>
          {this.props.children}
        </div>
      );
    }

    return element;
  },
});



// WEBPACK FOOTER //
// ./app/javascript/components/Feature.js